import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import PropTypes from 'prop-types';

import * as POSSelectors from 'PointOfSale/selectors';
import LookUp from 'PointOfSale/modules/lookup/component/LookUp';
import * as LookUpActions from 'PointOfSale/modules/lookup/state/actions';
import * as QueueActions from 'PointOfSale/modules/queue/state/actions';
import * as GroupActions from 'PointOfSale/modules/group/state/actions';
import * as TeacherActions from 'PointOfSale/modules/teacher/state/actions';
import * as IndividualServingActions from 'PointOfSale/modules/individualServing/state/actions';
import * as OtherActions from 'PointOfSale/modules/other/state/actions';
import { SessionTypes } from 'PointOfSale/modules/common/constants';
import * as MealCounterActions from 'PointOfSale/modules/cepCard/state/actions';
import { getKeyboardActive } from 'Common/UI/state/selectors';
import { getValue } from 'Common/Components/Keyboard/withKeyboard';

class LookUpContainer extends Component {
  state = {
    padScrollBottom: false,
  };

  getSearchResults = _.debounce(this.props.LookUpActions.search, 650);

  componentDidMount() {
    const { activeSession } = this.props;
    if (_.includes([SessionTypes.Group, SessionTypes.Teacher], activeSession)) {
      this.getSearchResults();
    }
  }

  onLookupClose = () => {
    this.props.LookUpActions.showLookup(false);
    this.props.LookUpActions.resetLookup();
  };

  onSearchChange = event => {
    const currentSearchTerm = getValue(event);
    this.props.LookUpActions.updateLookUpQuery({
      term: currentSearchTerm,
    });
    this.getSearchResults();
  };

  toggleVisitingStudentStatus = () => {
    this.props.LookUpActions.updateLookUpQuery({
      visitingStudent: !this.props.lookUpQuery.visitingStudent,
    });
    this.getSearchResults();
  };

  onItemSelect = item => {
    const {
      activeSession,
      hasMealCounterSession,
      MealCounterActions,
      QueueActions,
      TeacherActions,
    } = this.props;
    switch (activeSession) {
      case SessionTypes.Queue:
        if (hasMealCounterSession) {
          MealCounterActions.selectStudent(item);
        } else {
          QueueActions.addToQueue(item);
        }
        break;
      case SessionTypes.Teacher:
        TeacherActions.selectTeacher(item);
        break;
      default:
        break;
    }
    this.onLookupClose();
  };

  onLookUpInputFocus = () => {
    const { keyboardActive } = this.props;

    if (keyboardActive) {
      this.setState({
        padScrollBottom: true,
      });
    }
  };

  onLookUpInputBlur = () => {
    const { keyboardActive } = this.props;

    if (keyboardActive) {
      this.setState({
        padScrollBottom: false,
      });
    }
  };

  render() {
    const {
      searchResults,
      showLoading,
      activeSession,
      showLookUp,
      lookUpQuery,
      message,
    } = this.props;
    const { term, visitingStudent } = lookUpQuery;
    const { padScrollBottom } = this.state;
    return (
      <LookUp
        onSearchChange={this.onSearchChange}
        searchTerm={term}
        searchResults={searchResults}
        onLookupClose={this.onLookupClose}
        showLoading={showLoading}
        visitingStudents={visitingStudent}
        onItemSelect={this.onItemSelect}
        toggleVisitingStudentStatus={this.toggleVisitingStudentStatus}
        activeSession={activeSession}
        showLookUp={showLookUp}
        onLookUpInputFocus={this.onLookUpInputFocus}
        onLookUpInputBlur={this.onLookUpInputBlur}
        padScrollBottom={padScrollBottom}
        message={message}
      />
    );
  }
}

LookUpContainer.propTypes = {
  LookUpActions: PropTypes.objectOf(PropTypes.func),
  QueueActions: PropTypes.objectOf(PropTypes.func),
  searchResults: PropTypes.array,
  showLoading: PropTypes.bool,
  session: PropTypes.object,
  activeSession: PropTypes.string,
  TeacherActions: PropTypes.object,
};

const mapStateToProps = state => ({
  searchResults: POSSelectors.getSearchResults(state),
  message: POSSelectors.getMessage(state),
  sessions: POSSelectors.getSessions(state),
  activeSession: POSSelectors.getActiveSession(state),
  showLoading: POSSelectors.getShowLoading(state),
  showLookUp: POSSelectors.getShowLookUp(state),
  lookUpQuery: POSSelectors.getQuery(state),
  hasMealCounterSession: POSSelectors.hasMealCounterSession(state),
  keyboardActive: getKeyboardActive(state),
});

const mapDispatchToProps = dispatch => ({
  OtherActions: bindActionCreators(OtherActions, dispatch),
  MealCounterActions: bindActionCreators(MealCounterActions, dispatch),
  LookUpActions: bindActionCreators(LookUpActions, dispatch),
  QueueActions: bindActionCreators(QueueActions, dispatch),
  GroupActions: bindActionCreators(GroupActions, dispatch),
  TeacherActions: bindActionCreators(TeacherActions, dispatch),
  IndividualServingActions: bindActionCreators(
    IndividualServingActions,
    dispatch
  ),
  dispatch,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LookUpContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/container/LookUpContainer.js